import http from "../config/axiosConfig/http-common";
import { GetTiposFrete, SetTiposFrete } from "../config/localstorageConfig/localstorage";
import ServiceBase from "./service.base";

class TabelaFreteService extends ServiceBase {

  getAll(filter) {
    //return http.get("/clientes?$top=10");
    return http.get("/tabelasfrete" + this.getFilter(filter));
  }

  getTiposFrete() {
    //return http.get("/clientes?$top=10");
    return http.get("/tabelasfrete/tiposfrete");
  }

  get(id) {
    return http.get(`/tabelasfrete/${id}`);
  }

  async setCache() {
    const tiposfrete = GetTiposFrete();
    if (tiposfrete) {
      return;
    }

    try {
      const response = await http.get("/tabelasfrete/tiposfrete");
      SetTiposFrete(response.data.value);
    } catch (e) {
      console.error("Erro ao carregar tipos frete:", e);
      throw e;
    }
  }
}

export default new TabelaFreteService();